import * as api from "../Api";

export const admin_stock_received_yearly_cost = () => async (dispatch) => {
  try {
    const { data } = await api.admin_stock_received_yearly_cost();
    dispatch({ type: "ADMIN_STOCK_RECEIVED_YEARLY", payload: data });
  } catch (error) {}
};
